var map = {
	"./Logotype-fa.png": "bc9d",
	"./Sign.svg": "de38",
	"./avatar.png": "1195",
	"./dave-hoefler-2Mv2Ph9aMEc-unsplash.jpg": "29a6",
	"./iconfinder_map-marker_299087.png": "1a98",
	"./logo.bak.png": "56ad",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";